module.exports = __webpack_public_path__ + "static/media/stage.5c61feff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/sponsorships/stage.jpg
// module id = 571
// module chunks = 6